import countries from "./Enum/CountryEnum"

const convertCountry = (country) => countries.filter(e => e.slug == country)

export default convertCountry